import { gql } from '@apollo/client'

export const GET_DISCOUNT_PLAN = gql`
    query getShareAndDiscount($filter: ShareAndDiscountFilterInput, $page: PageInput!) {
        getShareAndDiscount(filter: $filter, page: $page) {
            code
            success
            message
            total_count
            share_and_discounts {
                id
                code
                validity
                config
                discount_status
                user_audit {
                    created_date
                    created_by
                    modified_date
                    modified_by
                }
                influencer_name {
                    en
                    ar
                }
                route_ids
                trip_ids
                route_type
                max_uses
            }
        }
    }
`
